import React, { useState, useEffect } from "react";

import {
  TextField,
  Alert,
  Tooltip,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  Select as MSelect,
  MenuItem,
} from "@mui/material";
import { Update, Delete } from "@mui/icons-material";
import Select, { components } from "react-select";
import apiUrl from "../api";

import axios from "axios";

const CustomOption = (props) => {
  return (
    <Tooltip
      title="color"
      placement="left"
      PopperProps={{
        style: { zIndex: 10001 },
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -10],
            },
          },
        ],
        sx: {
          "& .MuiTooltip-tooltip": {
            fontSize: "14px",
            backgroundColor: `${props.data.tooltip}`,
            color: ` ${props.data.tooltip}`,
          },
        },
      }}
    >
      <div>
        <components.Option {...props} />
      </div>
    </Tooltip>
  );
};

const DeleteDialog = (props) => {
  const [selectedPriority, setSelectedPriority] = useState("");

  const handlePriorityDelete = async (e) => {
    e.preventDefault();
    props.setError("");
    props.setSuccess("");

    // Add your API call here to delete the priority
    // console.log(`Bearer ${props.user.token.toString()}`);
    try {
      const response = await axios.delete(
        `${apiUrl}/ticket-options/deletePriorityOption/${props.selectedPriority}`,
        {
          replacePriority: selectedPriority,
          headers: {
            Authorization: `Bearer ${props.user.token}`,
          },
        }
      );

      props.setPriorities(
        props.priorities.filter((priority) => priority._id !== selectedPriority)
      );

      props.setSuccess("Priority deleted successfully.");
      props.onClose();
    } catch (error) {
      console.log(error);
      props.setError("Failed to delete priority. Please try again.");
      props.onClose();
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete Priority"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Select a priority to replace the deleted priority with.
        </DialogContentText>

        <MSelect
          value={selectedPriority}
          onChange={(e) => setSelectedPriority(e.target.value)}
          fullWidth
          sx={{
            width: "100%",
          }}
        >
          {props.priorities
            .filter((priority) => priority._id !== props.selectedPriority)
            .map((priority) => (
              <MenuItem key={priority._id} value={priority._id}>
                {priority.title}
              </MenuItem>
            ))}
        </MSelect>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          onClick={handlePriorityDelete}
          autoFocus
          disabled={selectedPriority === ""}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const UpdatePriorityOption = () => {
  const [priorityName, setPriorityName] = useState("");
  const [priorityColor, setPriorityColor] = useState("#FA0808");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [priorities, setPriorities] = useState([]);
  const [selectedPriority, setSelectedPriority] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchPriorities = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/ticket-options/getPriorityOptions`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        setPriorities(response.data.priorityOptions);
      } catch (error) {
        setError("Failed to fetch priorities. Please try again.");
      }
    };
    fetchPriorities();
  }, []);

  const handlePrioritySelect = (selectedOption) => {
    setSelectedPriority(selectedOption.value);
    setPriorityName(selectedOption.label);
    setPriorityColor(selectedOption.tooltip);
  };

  const handleUpdatePriority = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (priorityName === "") {
      return setError("Priority name is required.");
    }

    // Add your API call here to update the priority
    try {
      const response = await axios.put(
        `${apiUrl}/ticket-options/updatePriorityOption/${selectedPriority}`,
        {
          title: priorityName,
          color: priorityColor,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setPriorities(
        [...priorities].map((priority) => {
          if (priority._id === selectedPriority) {
            return {
              ...priority,
              title: priorityName,
              color: priorityColor,
            };
          }
          return priority;
        })
      );

      setSuccess("Priority updated successfully.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Priority already exists.");
      } else {
        setError("Failed to update priority. Please try again.");
      }
    }
  };

  return (
    <div className="update-priority-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "10px",
          fontWeight: "600",
        }}
      >
        Edit Priority
      </h4>
      <Select
        value={selectedPriority.value}
        onChange={(selectedOption) => handlePrioritySelect(selectedOption)}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "var(--secondary-color)",
            primary25: "var(--tertiary-color)",
          },
        })}
        options={[
          ...priorities.map((priority) => ({
            value: priority._id,
            label: priority.title,
            tooltip: priority.color,
          })),
        ]}
        components={{ Option: CustomOption }}
        styles={{
          menu: (base) => ({
            ...base,
            zIndex: 1000, // Adjust this value as needed, ensuring it is higher than the z-index of other components
          }),
        }}
      />

      {selectedPriority && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <form
            onSubmit={handleUpdatePriority}
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "100%",
              alignItems: "center",
            }}
          >
            <TextField
              variant="outlined"
              label="Priority Name"
              placeholder="Priority Name"
              value={priorityName}
              onChange={(e) => setPriorityName(e.target.value)}
              fullWidth
              margin="normal"
              InputProps={{
                inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
              }}
            />
            <TextField
              variant="outlined"
              type="color"
              label="Label Color"
              value={priorityColor}
              onChange={(e) => setPriorityColor(e.target.value)}
              margin="normal"
              sx={{
                width: "20%",
              }}
              // Custom styling may be required for color input to look consistent
              InputProps={{
                inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
              }}
            />
            <button
              className="add-ticket-button__button"
              sx={{
                backgroundColor: "var(--primary-color)",
                color: "var(--primary-text-color)",
                fontSize: "15px",
                fontWeight: "600",
                width: "auto",
                padding: "10px 20px",
              }}
              onClick={() => {}}
            >
              <Update />
              <span>Update</span>
            </button>
          </form>
          <button
            className="add-ticket-button__button"
            sx={{
              backgroundColor: "var(--primary-color)",
              color: "var(--primary-text-color)",
              fontSize: "15px",
              fontWeight: "600",
              width: "auto",
              padding: "0px 20px",
            }}
            onClick={() => setDeleteDialogOpen(true)}
          >
            <Delete />
            <span>Delete</span>
          </button>
          <DeleteDialog
            open={deleteDialogOpen}
            onClose={() => setDeleteDialogOpen(false)}
            priorities={priorities}
            setPriorities={setPriorities}
            selectedPriority={selectedPriority}
            setError={setError}
            setSuccess={setSuccess}
            user={user}
          />
        </div>
      )}
    </div>
  );
};

export default UpdatePriorityOption;
